module.exports = __webpack_public_path__ + "static/media/denos.3081eded.svg";